/**
 * @Author: zpc
 * @Description:
 * @DateTime: Created in 2022-04-28 09:53:30
 */
 
 import Api from "src/util/api";
 import {PageDo, Result, ResultPageDo, PageResDo} from "src/types/base";
 export declare namespace roleDataConfigDOI {
 
     export interface RowDataI {
         role_name: string
         id: number
     }
 
     export interface QueryRowDataParamsI extends PageDo {
         keyword?: string
     }
 
     export interface QueryDetailResultI {
 
     }
 
     export interface OperateParamsI {
         
     }
 }

 export default class roleDataConfigApi {
	/**
	 * 查询列表
	 * @param {RoleConfigDOI.QueryRowDataParamsI} params
	 * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
	 */
	static async searchList(params: PageDo = {page_index: 1, page_size:100000000}):Promise<ResultPageDo<RoleConfigDOI.RowDataI[]>> {
		return Api.post('/auth_login/login/role/data', params)
	}
	/**
	 * 查询列表
	 * @param {{id: number}} params
	 * @returns {Promise<ResultPageDo<PeopleManageRowI[]>>}
	 */
	static async searchDetail (params: {id: number}): Promise<Result<RoleConfigDOI.QueryDetailResultI>> {
		return Api.post('/base/garage/detail', params)
	}
    
    /**
     * 批量添加角色资料权限关系
     * @param role_id 
     * @param data_categories_ids 
     */
    static async saveAuthority(role_id: number,data_categories_ids:number[]):Promise<Result<any>> {
		return Api.post('/management/role/data_categories/add', {role_id,data_categories_ids})
    }

    static async queryAuthorityByRol(role_id: number):Promise<Result<{data_categories_id: number,data_name: string}[]>> {
		return Api.post('/management/role/data_categories/data', {role_id})
    }
    
    /**
     * 查询资料类别
     */
    static async queryCategories():Promise<Result<any>> {
        return Api.post('/management/data_categories/query',{})
    }
}